<template>
    <b-card-text
        v-bind="$props"
    >
        <slot />
    </b-card-text>
</template>

<script>
import { BCardText } from 'bootstrap-vue'

export default {
    components: { BCardText },
    props: {
        textTag: { type: String, default: 'p' }
    }
}
</script>